import script from "./PageLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageLoader.vue?vue&type=script&setup=true&lang=ts"

import "./PageLoader.vue?vue&type=style&index=0&id=4fde1b6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fde1b6e"]])

export default __exports__